import { APP_URL, DEMO_SURVEY_URL } from '../config/links'
import {
  PRIMARY_CTA_TEXT,
  SECONDARY_CTA_TEXT,
  PRIMARY_CTA_MICROCOPY,
} from '../config/cta'
import TrackedCTA from './TrackedCTA'

/**
 * Standard primary + secondary CTA pair used across loop pages and homepage.
 *
 * Props:
 *   location — tracking label (e.g. "hero", "final-cta", "event-loop")
 *   showMicrocopy — render the PRIMARY_CTA_MICROCOPY line below the CTAs
 *   align — "left" | "center" (default "left")
 */
export default function LoopCTAs({ location, showMicrocopy = false, align = 'left' }) {
  const justify = align === 'center' ? 'justify-center' : 'justify-start'
  const textAlign = align === 'center' ? 'text-center' : 'text-left'

  return (
    <div className={textAlign}>
      <div className={`flex flex-col sm:flex-row gap-4 ${justify}`}>
        <TrackedCTA
          href={APP_URL}
          location={location}
          ctaName={PRIMARY_CTA_TEXT}
          className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-white bg-primary-600 hover:bg-primary-700 rounded-lg shadow-md transition-colors"
        >
          {PRIMARY_CTA_TEXT}
        </TrackedCTA>
        <TrackedCTA
          href={DEMO_SURVEY_URL}
          location={location}
          ctaName={SECONDARY_CTA_TEXT}
          className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-primary-600 bg-white border-2 border-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
        >
          {SECONDARY_CTA_TEXT}
        </TrackedCTA>
      </div>
      {showMicrocopy && (
        <p className="text-sm text-intelligence-500 mt-4">{PRIMARY_CTA_MICROCOPY}</p>
      )}
    </div>
  )
}
